/*
import React from 'react';

const Footer = () => (
  <footer className="mt-10 py-4 text-center text-xs text-gray-400">
    © {new Date().getFullYear()} CleanCity Garbage Complaint System
  </footer>
);

export default Footer;
*/


const Footer = () => (
  <footer className="mt-10 py-4 border-t border-gray-100 bg-white/70 backdrop-blur">
    <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-2">
      <p className="text-[11px] text-gray-500">
        © {new Date().getFullYear()} CleanCity Garbage Complaint System
      </p>
      <p className="text-[11px] text-gray-400">
        Built for smarter, cleaner neighborhoods 🌱
      </p>
    </div>
  </footer>
);

export default Footer;
